import React, {useState, useCallback, useEffect, useRef} from "react";
import Modal from "react-bootstrap/Modal";
import ApiService from "../../util/ApiService";

import Swal from "sweetalert2";
import "react-datepicker/dist/react-datepicker.css";
import AuthService from "../../util/AuthService";
import Switch from "react-switch";
import {DatePicker} from "antd"; // Importando corretamente

import Select from "react-select";
import "./../assets/css/PlantaoModal.css";
import UsersSearch from "./UsersSearch";
import HospitalSearch from "../../hospital/HospitalSearch";
import dayjs from "dayjs";
import "react-datepicker/dist/react-datepicker.css";
import ptBRLocale from "antd/es/date-picker/locale/pt_BR";


// **Extraindo RangePicker corretamente**
const {RangePicker} = DatePicker;

const PlantaoModal = ({show, handleClose, handleSubmit, duty}) => {
    const refUserSearch = useRef(null);
    const selectInputRef = useRef();
    const user = AuthService.getUserData();
    const hospitalSearchRef = useRef(null);
    const [dutyData, setDutyData] = useState({
        id: null,
        date_time: null,
        value: '',
        hospital_id: '',
        hospital: null,
        scale_id: null,
        date_time_end: null,
        department_id: null,
        department: null,
        specialties: [],
        observation: '',
        validated_user: 1,

    });

    const [loading, setLoading] = useState(false); // Estado de carregamento
    const [companyAssistant, setCompanyAssistant] = useState(false); // Estado de carregamento
    const [hospitalOptions, setHospitalOptions] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [specialtyOptions, setSpecialtyOptions] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [statusValueDuty, setStatusValueDuty] = useState(false);


    const [tempDateTime, setTempDateTime] = useState(null);

    const fetchSpecialties = async () => {
        try {
            const storedSpecialties = localStorage.getItem("specialties-select");

            if (storedSpecialties) {
                setSpecialtyOptions(JSON.parse(storedSpecialties));
            } else {
                const response = await ApiService.send('get', `${process.env.REACT_APP_URL_API}specialties/list`);

                const {data} = ApiService.handleApiResponse(response);

                const options = data.map(specialty => ({
                    value: specialty.id,
                    label: specialty.name,
                }));
                localStorage.setItem("specialties-select", JSON.stringify(options));
                setSpecialtyOptions(options);
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    const fetchListCompanyAssistant = async () => {

        try {

            const companyId = AuthService.getCompanyId();
            setCompanyAssistant([]);
            if(companyId) {
                const response = await ApiService.send(
                    "get",
                    `${process.env.REACT_APP_URL_API}users/list-assistant`,
                    {id: companyId},
                    true
                );

                const {data} = ApiService.handleApiResponse(response);
                setCompanyAssistant(data?.data);
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };


    const fetchDepartment = async () => {
        try {
            const response = await ApiService.send('post', `${process.env.REACT_APP_URL_API}departments/list-department`, {
                all: true,
                status: 'S',
                filter_manager: user?.users_type_id == 1 ? 1 : 0,
            }, true);
            const {data} = ApiService.handleApiResponse(response);
            const options = data.map(department => ({
                value: department.id,
                label: department.name,
                hourly_rate: department.value,
            }));
            setDepartmentOptions(options);

            // Se existir um valor em dutyData.department_id, atualizar o departamento selecionado
            if (dutyData.department_id) {
                const selectedDepartment = options.find(option => option.value === dutyData.department_id);
                if (selectedDepartment) {
                    setDutyData(prev => ({
                        ...prev,
                        department_id: selectedDepartment.value,

                    }));
                }
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };




    const onHospitalSelect = (hospital) => {
        if (hospital) {
            const departmentRate = parseFloat(dutyData.department?.hourly_rate || 0);
            const hospitalRate = parseFloat(hospital?.hourly_rate || 0);
            const finalRate = departmentRate > 0 ? departmentRate : hospitalRate;


            setDutyData((prev) => ({
                ...prev,
                hospital_id: hospital.value,
                hospital: hospital,
                hourly_rate: finalRate
            }));

            setStatusValueDuty(!isNaN(finalRate) && finalRate > 0);
        } else {
            setDutyData((prev) => ({
                ...prev,
                hospital_id: null,
                hospital: null,
                hourly_rate: parseFloat(dutyData.department?.hourly_rate || 0)
            }));
        }
    };

    const formatDate = (date) => {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
            return '';
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const onSubmit = async (e) => {


        setLoading(true); // Inicia o carregamento

        const formattedDuty = {
            ...dutyData,
            date_time: formatDate(dutyData.date_time),
            date_time_end: formatDate(dutyData.date_time_end),
            id: duty ? duty.id : null
        };

        const apiEndpoint = duty?.id ? `${process.env.REACT_APP_URL_API}duty/update` : `${process.env.REACT_APP_URL_API}duty/register`;
        const method = duty?.id ? 'put' : 'post';

        try {
            await ApiService.send(method, apiEndpoint, formattedDuty, true);
            Swal.fire({
                title: 'Sucesso!',
                text: duty ? 'Plantão atualizado com sucesso!' : 'Plantão cadastrado com sucesso!',
                icon: 'success',
                confirmButtonText: 'OK'
            }).then((result) => {
                if (result.isConfirmed) {
                    handleClose(true); // Só fecha depois que o usuário clicar em OK
                }
            });
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false); // Finaliza o carregamento
        }
    };



    const handleDepartmentSelect = (selectedOption) => {
        const updatedDepartment = selectedOption || null;

        const departmentRate =selectedOption?.hourly_rate;
        const hospitalRate =dutyData.hospital?.hourly_rate ;
        let  finalRate = departmentRate !== null ? departmentRate : hospitalRate;

        if(finalRate === null){
            finalRate = 0;
        }

        setDutyData((prev) => ({
            ...prev,
            department_id: updatedDepartment?.value || null,
            department: updatedDepartment,
            hourly_rate: finalRate,
        }));
    };



    useEffect(() => {
        if (
            dutyData.date_time &&
            dutyData.date_time_end && dutyData.id === null
        ) {

            const start = new Date(dutyData.date_time);
            const end = new Date(dutyData.date_time_end);

            const diffMs = end.getTime() - start.getTime(); // Diferença em milissegundos
            const diffHours = diffMs / 1000 / 60 / 60; // Converter para horas

            const totalValue = parseFloat((diffHours * dutyData.hourly_rate).toFixed(2));


            setDutyData(prev => ({
                ...prev,
                value: totalValue,
            }));
        }
    }, [dutyData.department_id, dutyData.date_time_end, dutyData.hourly_rate]);


    const resetDutyData = () => {

        if (selectInputRef.current) {
            selectInputRef.current.clearValue(); // <- força o select a resetar visualmente
        }


        if (hospitalSearchRef.current) {
            hospitalSearchRef.current.clearHospital();
        }

        if (refUserSearch.current) {
            refUserSearch.current.clearUser();
        }


        setHospitalOptions(null);
        setErrorMessage('');
        handleClearDateRange();

        setDutyData({
            id: '',
            date_time: null,
            date_time_end: null,
            value: 0,
            hospital_id: '',
            department_id: null,
            specialties: null, // <- limpa os especialistas
            observation: '',
            self_approval: 0,
            validated_user: 1,
            id_user_accepted: null,
            scale_id: null
        });

    };

    useEffect(() => {
        if (show) {
            fetchSpecialties();
            fetchDepartment();
            fetchListCompanyAssistant();
            if (duty?.id > 0) {


                console.log(duty.lunch_time);
                setDutyData({
                    id: duty?.id,
                    date_time: duty ? (duty.date_time ? new Date(duty.date_time) : null) : null,
                    value: duty.value | null,
                    lunch_time:  duty.lunch_time ?  String(duty.lunch_time).padStart(5, '0').substring(0, 5) : null,
                    scale_id: duty?.scale_id,
                    hospital_id: duty.hospital_id || null,
                    date_time_end: duty?.date_time_end ? new Date(duty.date_time_end) : null,
                    self_approval: duty.self_approval || 0,
                    department_id: duty?.department_id,
                    specialties: duty.specialties?.map(specialty => ({value: specialty.id, label: specialty.name})),
                    observation: duty.observation || '',
                    validated_user: duty.validated_user || 1,
                    id_user_accepted: duty?.accept_user?.id || null,
                });

                if (duty?.scale_id > 0) {
                    setStatusValueDuty(true);
                } else {
                    setStatusValueDuty(false);
                }


                if (duty.hospital) {
                    setHospitalOptions(
                        duty.hospital
                            ? {
                                id: duty.hospital.id,
                                name: duty.hospital.name,
                                city_name: duty.hospital.city_name || duty.hospital.city?.name,
                                uf: duty.hospital.uf || duty.hospital.city?.uf,
                            }
                            : null
                    );

                }
            } else {
                resetDutyData();
            }
            setErrorMessage('');
        }
    }, [show, duty]);


    const handleClearDateRange = () => {
        setDutyData(prev => ({
            ...prev,
            date_time: null,
            date_time_end: null,
        }));

    };


    return (
        <>

            <Modal show={show} onHide={handleClose} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{duty?.id ? 'Editar Plantão' : 'Cadastro de Plantão'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="row">
                            <div className="col-8 form-group">

                                <HospitalSearch
                                    ref={hospitalSearchRef}
                                    onHospitalSelect={onHospitalSelect}
                                    initialHospital={hospitalOptions || null}
                                    buttonAdd={false}
                                    validateManager={true}

                                />
                            </div>
                            <div className="col-4 form-group">
                                <label>Tempo de Intervalo</label>
                                <input
                                    type="time"
                                    className="form-control"
                                    value={dutyData.lunch_time || "00:00"}
                                    onChange={(e) => {
                                        const value = e.target.value; // valor no formato HH:mm
                                        setDutyData((prev) => ({
                                            ...prev,
                                            lunch_time: value,
                                        }));
                                    }}
                                    style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                                />

                            </div>

                            {/*<div className="col-6 form-group">*/}
                            {/*    <label>Especialidades</label>*/}
                            {/*    <Select*/}
                            {/*        isMulti*/}
                            {/*        ref={selectInputRef}*/}
                            {/*        value={dutyData.specialties || []}*/}
                            {/*        onChange={(selectedOptions) =>*/}
                            {/*            setDutyData({*/}
                            {/*                ...dutyData,*/}
                            {/*                specialties: selectedOptions || []*/}
                            {/*            })*/}

                            {/*        }*/}
                            {/*        options={specialtyOptions}*/}
                            {/*        isDisabled={!!duty?.id}*/}
                            {/*        placeholder="Selecione"*/}
                            {/*        className="react-select-container"*/}
                            {/*        classNamePrefix="react-select"*/}
                            {/*        menuPortalTarget={document.body}*/}
                            {/*        styles={{*/}
                            {/*            menuPortal: base => ({...base, zIndex: 9999}),*/}
                            {/*            menu: base => ({...base, zIndex: 9999}),*/}
                            {/*        }}*/}
                            {/*    />*/}

                            {/*</div>*/}

                        </div>

                        <div className="row">
                            <div className="col-4 form-group">
                                <label>Aceitar o primeiro interessado{"  "}
                                    <span>
                                        <i className="fa fa-info" title="Selecionar automaticamente o primeiro plantonista que se candidatar ao
                                                plantão"></i>
                                         </span>
                                </label>
                                <div className="form-check">
                                    <Switch
                                        checked={Number(dutyData.self_approval) === 1}
                                        onChange={(checked) =>
                                            setDutyData({
                                                ...dutyData,
                                                self_approval: checked ? 1 : 0,
                                            })
                                        }
                                        onColor="#0d6efd"
                                        offColor="#ccc"
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        title="Selecionar automaticamente o primeiro plantonista que se candidatar ao plantão"
                                        className="react-switch"
                                    />
                                </div>
                            </div>
                            <div className="col-4 form-group">
                                <label>Data e Hora de Início</label>
                                <DatePicker
                                    format="DD/MM/YYYY HH:mm"
                                    locale={ptBRLocale}
                                    showTime={{format: "HH:mm", defaultValue: dayjs("00:00", "HH:mm")}}
                                    value={dutyData.date_time ? dayjs(dutyData.date_time) : null}
                                    onCalendarChange={(value) => {
                                        if (value && value.isValid()) {
                                            setDutyData((prev) => ({
                                                ...prev,
                                                date_time: value.toDate(),
                                            }));
                                        }
                                    }}
                                    getPopupContainer={() => document.body}
                                    popupStyle={{zIndex: 9999}}
                                    style={{width: "100%"}}
                                />
                            </div>

                            <div className="col-4 form-group">
                                <label>Data e Hora de Término</label>
                                <DatePicker
                                    showTime={{format: 'HH:mm', showNow: false}}
                                    format="DD/MM/YYYY HH:mm"
                                    locale={ptBRLocale}
                                    value={dutyData.date_time_end ? dayjs(dutyData.date_time_end) : null}
                                    onCalendarChange={(date) => {
                                        setDutyData(prev => ({
                                            ...prev,
                                            date_time_end: date ? date.toDate() : null,
                                        }));
                                    }}
                                    className="form-control"
                                    style={{width: '100%'}}
                                    getPopupContainer={(triggerNode) => document.body}
                                    popupStyle={{zIndex: 9999}} // <- garante que o popup do calendário fique acima
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 form-group">
                                <label>Valor do Plantão</label>
                                <input
                                    type="number"
                                    placeholder="Digite o valor do plantão"
                                    value={dutyData.value ?? ''}// <- aqui é o segredo
                                    disabled={dutyData?.scale_id !== null && statusValueDuty}
                                    onChange={(e) =>
                                        setDutyData({
                                            ...dutyData,
                                            value: e.target.value,
                                        })
                                    }
                                    className="form-control"
                                />

                            </div>
                            <div className="col-8 form-group">
                                <label>Departamento</label>
                                <Select
                                    isClearable={true}

                                    value={departmentOptions.find(option => option.value === dutyData.department_id) || null} // Define valor inicial
                                    onChange={handleDepartmentSelect}
                                    options={departmentOptions}


                                    placeholder="Selecione o departamento"
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    isDisabled={!!duty?.id} // Desabilitar no modo de edição
                                    menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                    styles={{
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999
                                        }), // Definindo z-index alto
                                        menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Observação</label>
                            <textarea
                                placeholder="Digite a observação"
                                value={dutyData.observation || null}
                                onChange={(e) => setDutyData({...dutyData, observation: e.target.value})}
                                className="form-control"
                            />
                        </div>
                        <div className="row">
                            {companyAssistant?.validated_user == 0 && (
                                <div className="col-4 form-group">
                                    <label>Validar Credenciamento{"  "}
                                        <span>
                                        <i className="fa fa-info"
                                           title="Só permite o interesse de usuários que são credenciados a você."></i>
                                         </span>
                                    </label>
                                    <div className="form-check">
                                        <Switch
                                            checked={dutyData.validated_user === 1}
                                            onChange={(checked) => setDutyData({
                                                ...dutyData,
                                                validated_user: checked ? 1 : 0
                                            })}
                                            onColor="#0d6efd"
                                            offColor="#ccc"
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            className="react-switch"
                                            disabled={!!duty?.id} // Desabilitar no modo de edição
                                        />
                                    </div>

                                </div>
                            )}
                            <div className="col-8 form-group">
                                <UsersSearch
                                    ref={refUserSearch}
                                    situation="accepted"
                                    departmentId={dutyData?.department_id}
                                    initialUser={duty?.accept_user}
                                    onUserSelect={(user) =>
                                        setDutyData((prevFilters) => ({
                                            ...prevFilters,
                                            id_user_accepted: user?.value || "",
                                        }))
                                    }/>
                            </div>
                        </div>


                        {errorMessage && (
                            <div className="alert alert-danger mt-2" role="alert">
                                <div dangerouslySetInnerHTML={{__html: errorMessage}}/>
                            </div>
                        )}


                    </form>
                </Modal.Body>
                <Modal.Footer>
                    {!duty?.id && (
                    <button className="btn mt-2 mr-1  me-2" onClick={() => {
                        resetDutyData();             // limpa os dados
                    }}>
                        <i className="fa fa-eraser"></i> Limpar Campos
                    </button>
                    )}
                    <button type="button" className="btn mt-2 btn-secondary"

                            onClick={() => {
                                resetDutyData(); // ← limpa tudo ao fechar
                                handleClose(false);
                            }}>
                        <i className="fa fa-close"></i>{" "}Fechar
                    </button>
                    <button
                        type="button"
                        className="btn btn-info mt-2"
                        onClick={() => onSubmit()}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
            <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
            ></span>
                                Salvando...
                            </>
                        ) : duty?.id ? (
                            <>
                                <i className="fa fa-refresh me-2"></i> Atualizar
                            </>
                        ) : (
                            <>
                                <i className="fa fa-plus me-2"></i> Cadastrar
                            </>
                        )}
                    </button>

                </Modal.Footer>
            </Modal>


        </>
    )
        ;
};

export default PlantaoModal;
